module.exports = __webpack_public_path__ + "media/images/riders/KARL_MARKT-28724bbb0e2a3cdbf3cf3634e108c929.png";